import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Document, Page, pdfjs } from 'react-pdf';

import Button from 'components/Button';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();
function ModalDocumentoPdf(props) {
  const [pageNumber, setPageNumber] = useState(null);
  const [numPages, setNumPages] = useState(null);

  const handleClose = () => {
    props.close(false);
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function onSourceError(e) {
    
  }

  return (
    <Dialog open={!!props.open} onClose={handleClose} maxWidth="xl">
      <DialogTitle>Documento</DialogTitle>
      <DialogContent>
        <Document
          style={{ width: '100%' }}
          file={props.documento}
          onLoadError={console.error}
          onLoadSuccess={onDocumentLoadSuccess}
          onSourceError={onSourceError}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
          ))}
        </Document>
      </DialogContent>
      <DialogActions>
        <Button data-testid="count" onClick={handleClose} color="primary" autoFocus>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ModalDocumentoPdf;
